import type { Scale } from '@tunasong/schemas'
import { ScaleLib } from '../scale/index.js'

/**
 * Modulation helpers for thread B-v2.
 *
 * Full key-tracking is deliberately out of scope (separate thread per the spec).
 * The analyzer accepts an externally-supplied `modulationCandidate: Scale` and
 * decides whether to relabel the current chord against the candidate key.
 *
 * The exported helper here renders the candidate scale as a human-readable
 * suffix for the chord description ("(modulating to G major)"). It is the
 * smallest surface needed by the analyzer; future modulation-detection logic
 * (pattern recognition over the progression) will land in the same module.
 */

/** "G major" / "A minor" etc. — mirrors `ScaleLib.getName` for direct use in descriptions. */
export const formatModulationSuffix = (candidate: Scale): string =>
  `(modulating to ${ScaleLib.getName(candidate)})`
